import React, {useMemo, useRef, useState} from "react";
import Layout from "../../../common/Layout";
import SEO from "../../../common/SEO";
import FooterOne from "../../../common/footer/FooterOne";
import axios from "axios";
import IntegrationsCarousel from "../../../components/banner/integrations";
import {useTranslation} from 'react-i18next';
import RealtimeSyncWidget from "../../../components/widgets/RealtimeSyncWidget";
import { useLocation } from "react-router-dom";
import Demo from "../../../innerpages/Demo";
import ContactModalButton from "../../../components/common/ContactModalButton";

// Small helper components: section header bar and full-width spacer
const BlockHeader = ({ title, description = "", bg = true }) => (
    <div id="erp-intro" className={`edu-about-area ${bg ? 'about-style-3 bg-image' : ''}`} style={{ margin: "30px 0", padding: "4rem 0" }}>
        <div className="container eduvibe-animated-shape">
            <div className="row g-5 align-items-center">
                <div className="col-lg-12">
                    <div className="section-title text-center">
                        <h3 className="title">{title}</h3>
                        {description && <p className="description mt--20" style={{ maxWidth: 900, margin: "0 auto" }}>
                            {description}
                        </p>}
                    </div>
                </div>
            </div>
        </div>
    </div>
);
const FullWidthSpacer = () => (
  <div aria-hidden="true" style={{ width: "100%", height: 60, background: "linear-gradient(90deg,#f8fbff 0%, #f3f6fb 50%, #f8fbff 100%)", margin: "0 0" }} />
);

// Gastro-like small top spacer with background and white headline
const TopSpacer = ({ title = "", bgUrl }) => (
  <div className="edu-breadcrumb-area breadcrumb-style-1 ptb--35 ptb_md--40 ptb_sm--40 bg-image" style={{ backgroundImage: `url("${bgUrl}")` }}>
    <div className="container eduvibe-animated-shape">
      <div className="row">
        <div className="col-lg-12">
          <div className="breadcrumb-inner text-start">
            <div className="page-title">
              <h3 className="title"><span style={{ color: '#fff' }}>{title}</span></h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Gastro-like two-column module block with circular image and feature list
const ErpModule = ({title, desc, consultLabelKey, imageUrl, features = [], t }) => (
  <div className="edu-about-area about-style-3 edu-section-gap bg-image" style={{paddingTop: '20px', paddingBottom: '20px'}}>
    <div className="container eduvibe-animated-shape">
      <div className="row g-5">
        <div className="col-lg-12 section-title text-start">
          <div className="animated fadeInUp" style={{ animationDuration: '1s' }}>            
						<h3 className="title">{title}</h3>
            <div className="animated fadeInUp" style={{ animationDuration: '1s' }}>
              <p className="description mt--40" dangerouslySetInnerHTML={{ __html: desc }}/>
            </div>
          </div>
        </div>
        <div className="col-lg-6" id="delivery-module">
          <div className="inner">
            {imageUrl && (
              <div className="testimonial-left-image animated fadeIn" style={{ animationDuration: '1s', margin: '5rem 0px' }}>
                <div className="thumbnail">
                  <div className="circle-image-wrapper" style={{ width: '52rem' }}>
                    <img className="radius-round" src={imageUrl} alt={title} style={{ width: '50rem', height: '50rem', objectFit: 'cover' }} />
                    <div className="circle-image"><span></span><span></span></div>
                    <div className="btn-area" style={{display: "flex", gap: 16, flexWrap: "wrap", marginTop: 40, justifyContent: "center"}}>
                      <ContactModalButton>
                        {t(consultLabelKey)}
                      </ContactModalButton>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-6" id="delivery-module">
          <div className="inner">
            <h3>ERP rendszerünk vállalatirányítási moduljai:</h3>
            {features.map((f, idx) => (
              <div key={`gmf-${idx}`} className="col-lg-12 p-0 animated fadeInUp" style={{ animationDuration: '1s' }}>
                <div className="edu-feature-list">
                  <div className="content">
                    <h6 className="title d-flex align-items-center">
                      <i className="fas fa-check-square" style={{color: "#f78c45", marginRight: 6}}></i>
                      {f.title}
                    </h6>
                    {f.description && <p className="description">{f.description}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
        <div className="shape-image shape-image-1"><img src="/images/shapes/shape-21.png" alt="Shape Thumb" /></div>
        <div className="shape-image shape-image-2"><img src="/images/shapes/shape-13-04.png" alt="Shape Thumb" /></div>
        <div className="shape-image shape-image-3"><img src="/images/shapes/shape-03-05.png" alt="Shape Thumb" /></div>
        <div className="shape-image shape-image-4"><img src="/images/shapes/shape-15-02.png" alt="Shape Thumb" /></div>
      </div>
    </div>
  </div>
);

// Alternating gastro-like row with circular image and animated circles
const AlternatingErpRow = ({ title, consultLabelKey, features = [], imageUrl, reverse = false, t }) => (
  <div className="edu-about-area about-style-3 edu-section-gap bg-image" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
    <div className="container eduvibe-animated-shape">
      <div className="row g-5 align-items-center">
        {!reverse ? (
          <>
            <div className="col-lg-6">
              <div className="testimonial-left-image animated fadeIn" style={{ animationDuration: '1s', margin: '2rem 0' }}>
                <div className="thumbnail">
                  <div className="circle-image-wrapper" style={{ width: '52rem' }}>
                    <img className="radius-round" src={imageUrl} alt={title} style={{ width: '50rem', height: '50rem', objectFit: 'cover' }} />
                    <div className="circle-image"><span></span><span></span></div>
                    <div className="btn-area" style={{display: "flex", gap: 16, flexWrap: "wrap", marginTop: 40, justifyContent: "center"}}>
                      <ContactModalButton>
                        {t(consultLabelKey)}
                      </ContactModalButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inner">
                <div className="section-title text-start">
                  <div className="animated fadeInUp" style={{ animationDuration: '1s' }}>
                    <h3 className="title">{title}</h3>
                  </div>
                </div>
                <div className="animated fadeInUp" style={{ animationDuration: '1s' }}>
                  {features.map((f, idx) => (
                      <div key={`gmf-${idx}`} className="col-lg-12 p-0 animated fadeInUp" style={{ animationDuration: '1s' }}>
                        <div className="edu-feature-list">
                          <div className="content">
                            <h6 className="title d-flex align-items-center">
                              <i className="fas fa-check-square" style={{color: "#f78c45", marginRight: 6}}></i>
                              {f.title}
                            </h6>
                            {f.description && <p className="description">{f.description}</p>}
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="col-lg-6 order-lg-2">
              <div className="testimonial-left-image animated fadeIn" style={{ animationDuration: '1s', margin: '2rem 0' }}>
                <div className="thumbnail" style={{textAlign: 'right'}}>
                  <div className="circle-image-wrapper" style={{ width: '52rem' }}>
                    <img className="radius-round" src={imageUrl} alt={title} style={{ width: '50rem', height: '50rem', objectFit: 'cover' }} />
                    <div className="circle-image"><span></span><span></span></div>
                    <div className="btn-area" style={{display: "flex", gap: 16, flexWrap: "wrap", marginTop: 40, justifyContent: "center"}}>
                      <ContactModalButton>
                        {t(consultLabelKey)}
                      </ContactModalButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1">
              <div className="inner">
                <div className="section-title text-start">
                  <div className="animated fadeInUp" style={{ animationDuration: '1s' }}>
                    <h3 className="title">{title}</h3>
                  </div>
                </div>
                <div className="animated fadeInUp" style={{ animationDuration: '1s' }}>
                  {features.map((f, idx) => (
                      <div key={`gmf-${idx}`} className="col-lg-12 p-0 animated fadeInUp" style={{ animationDuration: '1s' }}>
                        <div className="edu-feature-list">
                          <div className="content">
                            <h6 className="title d-flex align-items-center">
                              <i className="fas fa-check-square" style={{color: "#f78c45", marginRight: 6}}></i>
                              {f.title}
                            </h6>
                            {f.description && <p className="description">{f.description}</p>}
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
        <div className="shape-image shape-image-1"><img src="/images/shapes/shape-21.png" alt="Shape Thumb" /></div>
        <div className="shape-image shape-image-2"><img src="/images/shapes/shape-13-04.png" alt="Shape Thumb" /></div>
        <div className="shape-image shape-image-3"><img src="/images/shapes/shape-03-05.png" alt="Shape Thumb" /></div>
        <div className="shape-image shape-image-4"><img src="/images/shapes/shape-15-02.png" alt="Shape Thumb" /></div>
      </div>
    </div>
  </div>
);

const ErpPageContent = () => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [formType, setFormType] = useState("quote"); // quote | consult | demo
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  // Company search (autocomplete)
  const [companyQuery, setCompanyQuery] = useState("");
  const [companyResults, setCompanyResults] = useState([]);
  const [companyLoading, setCompanyLoading] = useState(false);
  const [companyError, setCompanyError] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);

  // Simplified mode helpers & inline validation
  const [isPrivate, setIsPrivate] = useState(false);
  const [emailVal, setEmailVal] = useState("");
  const [emailTouched, setEmailTouched] = useState(false);
  const [phoneVal, setPhoneVal] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);
  const emailValid = useMemo(() => {
    const v = (emailVal || "").trim();
    return v.length > 5 && v.includes("@") && v.includes(".");
  }, [emailVal]);
  const phoneValid = useMemo(() => {
    const digits = (phoneVal || "").replace(/\D/g, "");
    return digits.length >= 9;
  }, [phoneVal]);
  const [submitError, setSubmitError] = useState(null);

  // Quick choices state and refs
  const [selectedOptions, setSelectedOptions] = useState({});
  const [otherNeeds, setOtherNeeds] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const formRef = useRef(null);

  const openModal = (type) => {
    setFormType(type);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Submit handler similar to Trade page
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitError(null);
    try {
      const form = e.target;
      const formData = new FormData(form);
      const payload = Object.fromEntries(formData.entries());
      payload.page = "Happy ERP";

      const res = await axios.post("/notifications/api/lead", payload);
      setResult(res.data?.code || "OK");
      form.reset();
      setEmailVal("");
      setPhoneVal("");
      setEmailTouched(false);
      setPhoneTouched(false);
      setSubmitError(null);
    } catch (e1) {
      console.error(e1);
      setSubmitError("Sajnáljuk, technikai hiba lépett fel. Kérjük, próbáld újra később, vagy vedd fel velünk a kapcsolatot.");
    } finally {
      setSubmitting(false);
    }
  };
  // const { pathname } = useLocation();
  // const host = (window.location.hostname || "").replace(/^www\./i, "").toLowerCase();
  //
  // const showHeaderImage = host === "happytrade.hu" && pathname === "/";

    return (
    <>
      <SEO title={t('erpPage.seoTitle')} description={t('erpPage.seoDesc')} url={typeof window !== 'undefined' ? window.location.href : undefined} canonical={typeof window !== 'undefined' ? window.location.href : undefined} />
      <Layout>
        {/*<div className="col-lg-12" style={{ marginBottom: "2rem" }}>*/}
        {/*  <div className="inner">*/}
        {/*    <img src={"https://images.happysolutions.hu/Happy_ERP_Header_1920x1080.png"} alt="Happy ERP"/>*/}
        {/*  </div>*/}
        {/*  <div className="col-lg-12">*/}
        {/*    <div className="inner">*/}
        {/*      <div className="col-lg-12 content text-start">*/}
        {/*        <h1 className="title">{t('erpPage.hero.title')}</h1>*/}
        {/*        <p className="description" style={{ fontSize: 18 }}>*/}
        {/*          {t('erpPage.hero.subtitle')}*/}
        {/*        </p>*/}
        {/*        <div className="btn-area" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>*/}
        {/*          <button className="edu-btn" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>*/}
        {/*            {t('erpPage.hero.ctaDemo')} <i className="icon-arrow-right-line-right"></i>*/}
        {/*          </button>*/}
        {/*          <button className="edu-btn btn-secondary" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>*/}
        {/*            {t('erpPage.hero.ctaConsult')}*/}
        {/*          </button>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/* Hero */}
        <div id="erp-hero" className="slider-area banner-style-3 bg-image" style={{ margin: "20px 0 0 0", padding: "2rem 0", backgroundColor: "linear-gradient(180deg, #f8fbff 0%, #ffffff 100%)",
          background: 'url(https://images.happysolutions.hu/ERP-oldal-hero--1920-500.png)', backgroundSize: 'cover', backgroundPosition: 'center center', minHeight: 400}}>
          <div className="d-flex align-items-center" style={{paddingBottom: 40}}>
            <div className="container eduvibe-animated-shape">
              <div className="row g-5 align-items-center">
                <div className="col-lg-12">
                  <div className="inner">
                    <div className="content text-start" style={{color: 'white'}}>
                      <h1 className="title" style={{color: 'white'}}>{t('erpPage.hero.title')}</h1>
                      <p className="description" style={{ fontSize: 18, color: 'white' }}>
                        {t('erpPage.hero.subtitle')}
                      </p>
                      <div className="btn-area" style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                        <Demo title={t('erpPage.hero.ctaDemo')}/>
												{/* <button className="edu-btn" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                          {t('erpPage.hero.ctaDemo')} <i className="icon-arrow-right-line-right"></i>
                        </button> */}
                        <button className="edu-btn btn-secondary" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                          {t('erpPage.hero.ctaConsult')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="banner-image">
                    <div className="banner-main-image">
                        {false && <img style={{borderRadius: 8}} className="img-01" src="/images/mini-cart.jpg" alt="Happy ERP"
                              width="640" height="480" decoding="async" fetchpriority="high"/>
                        }                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ErpModule
          title="Happy ERP"
          desc="A Happy ERP egy <b>komplex vállalatirányítási rendszer</b>, amely a vállalkozásod teljes működését egyetlen platformon fogja össze.
Beszerzés, raktár, gyártás, pénzügy és riportok – <b>valós idejű adatokkal</b>, egy helyen.
<b>Real-time információkra épülő vezetői döntéshozatalt</b> tesz lehetővé. A rendszer <b>döntéstámogató eszközként<b> segíti a cégvezetői munkát.
Elszigetelt rendszerek és duplikált, nehezen összefésülhető adatok helyett <b>folyamatában látod céged napi működését</b> és eredményességét, <b>amely a stratégiai döntéshozatalt támogatja.</b>
Komplex, moduláris, testre szabható és felhő alapú megoldás, központi, személyre szabható műszerfallal. Magyar fejlesztés, folyamatos innovációval és hazai támogatással."
          consultLabelKey={'tradePage.hero.ctaConsult'}
          imageUrl="https://images.happysolutions.hu/elso-kep-a-fiatal-srac%20helyett.jpg"
          features={[
            { title: "Beszerzés & beszállítók", description: "Az automatizált rendelési és jóváhagyási folyamatok, valamint az intelligens készletfeltöltés biztosítják az optimalizált beszerzést és a stabil készletszintet." },
            { title: "Raktár és logisztika", description: "A rendszer támogatja több raktár kezelését, biztosítja a pontos leltárt, és valós időben követi a szállítmányokat és csomagokat." },
            { title: "Készletgazdálkodás és raktárkezelés", description: "A rendszer biztosítja a készletmozgások pontos követését, a raktárkészlet átlátható kezelését és az optimális készletszint fenntartását." },
            { title: "Pénzügy és számlázás", description: "Rendszerünk biztosítja a NAV-kompatibilis számlázást, támogatja a Számlázz.hu és Billingo integrációt, valamint egyszerű könyvelési exportot kínál." },
            { title: "Együttműködés a könyveléssel", description: "A rendszer előkészíti és strukturált formában biztosítja a könyvelési adatokat, megkönnyítve az együttműködést a könyvelővel." },
            { title: "Riportok, BI", description: "Valós idejű riportok és kulcsmutatók segítik a működés folyamatos nyomon követését és a gyors vezetői döntéseket." },
          ]}
          t={t}
        />
        {/*<FullWidthSpacer />*/}

        {/* Alternating sections (ERP) */}
        <AlternatingErpRow
          title="Értékesítés & CRM"
          consultLabelKey={'tradePage.hero.ctaConsult'}
          imageUrl="https://images.happysolutions.hu/csaj-helyett-crm-hez.jpg"
          reverse
          features={[
            { title: "Ajánlatok, rendelések, számlák és kintlévőségek", description: "A rendszer egy központi felületen kezeli az értékesítési dokumentumokat és a pénzügyi státuszokat. Az ajánlattól a számlázásig minden lépés nyomon követhető, beleértve a kintlévőségek kezelését is."},
            { title: "A teljes értékesítési folyamat követése", description: "Az értékesítési folyamat minden szakasza strukturáltan és átláthatóan követhető. A rendszer biztosítja, hogy egyetlen üzleti lehetőség se vesszen el a folyamat során."},
            { title: "Átlátható ügyfélkezelés", description: "Minden ügyfélhez részletes adatlap tartozik, amely tartalmazza a vásárlási előzményeket és a kapcsolódó tevékenységeket. Az aktivitás napló teljes képet ad az ügyfélkapcsolat történetéről átláthatóvá teszi az ügyfélkezelést."},
            { title: "Automatizmusok és értesítések", description: "A rendszer automatikus emlékeztetőkkel és folyamatvezérelt értesítésekkel támogatja a napi feladatokat. Ez csökkenti a manuális adminisztrációt és növeli a reakcióidő hatékonyságát."},
            { title: "Értesitők, kampányok és hűségprogramok", description: "A beépített kommunikációs eszközök (SMS küldés, marketing modul, hűségprogram) lehetővé teszik az ügyfelek célzott elérését különböző csatornákon keresztül. A marketing kampányok és hűségprogramok eredményei mérhetőek és visszakövethetőek."},
            { title: "Teljesítménymutatók, statisztikák és elemzések", description: "A rendszer valós idejű riportokkal és KPI-mutatókkal támogatja az értékesítési teljesítmény elemzését. Az adatok segítik a stratégiai döntéshozatalt és az ügyfélkapcsolatok fejlesztését."},
          ]}
          t={t}
        />
        <AlternatingErpRow
          title="Raktár & logisztika"
          consultLabelKey={'tradePage.hero.ctaConsult'}
          imageUrl="https://images.happysolutions.hu/raktar-es-logisztika.jpg"
          features={[
            { title: "Több raktár kezelése", description: "Valós idejű készletinformáció több telephelyen, automatikus adat-szinkronizálással. A rendszer biztosítja, hogy minden raktár ugyanazt a naprakész adatállományt használja."},
            { title: "FIFO / LIFO és sarzs", description: "FIFO/LIFO készletkezelés, sarzskövetés és minőségmegőrzési idők nyilvántartása egy rendszerben. A pontos nyomon követés csökkenti a veszteséget és támogatja a megfelelőséget."},
            { title: "Szállítmánykövetés", description: "Szállítmányok, csomagok és szállítólevelek követése a beérkezéstől a kiszállításig. A rendszer átlátható logisztikai folyamatokat biztosít."},
            { title: "Vonalkód és QR", description: "Automatikus címkézés, vonalkód- és QR-kód támogatás a gyors és pontos azonosításhoz. A digitalizált folyamatok csökkentik a hibalehetőséget és gyorsítják a raktári műveleteket."},
            { title: "Raktári mozgások kezelése", description: "Raktárközi áthelyezések, mozgások és leltározási folyamatok strukturált kezelése. A rendszer biztosítja a készletmozgások teljes visszakövethetőségét."},
            { title: "Logisztikai riportok", description: "Részletes logisztikai kimutatások és teljesítménymutatók a készletgazdálkodás optimalizálásához. A valós idejű adatok támogatják a hatékony tervezést és döntéshozatalt."},
          ]}
          t={t}
        />
        <AlternatingErpRow
          title="Pénzügy & riportok"
          consultLabelKey={'tradePage.hero.ctaConsult'}
          imageUrl="https://images.happysolutions.hu/pe%CC%81nzu%CC%88gyi-modul.jpg"
          reverse
          features={[
            { title: "Pénzügyi átláthatóság", description: "Bevételek, kiadások, számlák és kintlévőségek kezelése egy rendszerben. A központi pénzügyi áttekintés stabil alapot ad a napi működéshez."},
            { title: "Integrált számlázás", description: "NAV-kompatibilis számlázás Számlázz.hu és Billingo integrációval. A rendszer biztosítja a gördülékeny adatkapcsolatot és a jogszabályi megfelelést."},
            { title: "Könyvelési támogatás", description: "Automatikus könyvelési exportok és banki egyeztetések egyszerűsítik a pénzügyi adminisztrációt. A strukturált adatkezelés megkönnyíti az együttműködést a könyveléssel."},
            { title: "Vezetői dashboardok", description: "Valós idejű pénzügyi dashboardok és BI kimutatások biztosítanak pontos rálátást a működésre. Az adatok támogatják a gyors és megalapozott döntéseket."},
            { title: "Automatikus értesítések", description: "Rendszeres figyelmeztetések a kintlévőségekről, határidőkről és pénzügyi mutatókról. Ez segíti a kockázatok időbeni kezelését."},
            { title: "Pénzügyi elemzések", description: "Részletes pénzügyi riportok és KPI-ok segítik a vállalat eredményességének folyamatos nyomon követését. Az elemzések támogatják a stratégiai tervezést."},
          ]}
          t={t}
        />

        {/* Benefits */}
        <BlockHeader bg={false} title="Miért válaszd a Happy ERP rendszert?" description={"A rendszer, ami nem gátol, hanem lendületet ad."}/>
        <div id="erp-benefits" className="edu-about-area bg-color-white" style={{ margin: "30px 0", padding: "2rem 0 3rem" }}>
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="service-card service-card-3">
                  <div className="content">
                    <h5 className="title">Több értékesítés, kevesebb adminisztráció.</h5>
                    <ul>
                      <li>Automatizált rendelés- és számlakezelés</li>
                      <li>Webshop, POS és raktár összekapcsolva</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card service-card-3">
                  <div className="content">
                    <h5 className="title">Mindent egyben kezelhetsz. Okosan. Gyorsan.</h5>
                    <ul>
                      <li>Integráció futárszolgáltatókkal (Wolt, GLS, Foxpost stb.)</li>
                      <li>Valós idejű készlet- és árkezelés</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card service-card-3">
                  <div className="content">
                    <h5 className="title">Egyszerű bevezetés és bővíthetőség.</h5>
                    <ul>
                      <li>Moduláris felépítés, skálázható megoldás</li>
                      <li>Magyar támogatás és oktatás</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*<FullWidthSpacer />*/}

        {/* Features */}
        <BlockHeader title="Főbb funkciók" description="A legfontosabb eszközök a mindennapi működéshez." />
        <div id="erp-features" className="edu-about-area bg-color-white" style={{ margin: "0 0", padding: "2rem 0 3rem" }}>
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="service-card service-card-3">
                  <div className="content">
                    <h5 className="title">Készletkezelés és raktár</h5>
                    <ul>
                      <li>Valós idejű készletnyilvántartás</li>
                      <li>Több raktár támogatása és leltár</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card service-card-3">
                  <div className="content">
                    <h5 className="title">Értékesítés és számlázás</h5>
                    <ul>
                      <li>Számlázz.hu / Billingo / NAV integráció</li>
                      <li>POS és online értékesítés összekapcsolása</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="service-card service-card-3">
                  <div className="content">
                    <h5 className="title">Integrációk</h5>
                    <ul>
                      <li>Wolt, GLS, Foxpost, Barion, OTP Simple, Stripe</li>
                      <li>Shoprenter, UNAS, Shopify és továbbiak</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*<FullWidthSpacer />*/}

        {/* Integrations */}
        {/*<BlockHeader title="Integrációk" description="Kapcsolódások partnereinkhez" />*/}
        {/*<div id="integrations" className="container" style={{ padding: "2rem 0" }}>*/}
        {/*  <IntegrationsCarousel />*/}
        {/*</div>*/}

        {/*<FullWidthSpacer />*/}

        {/* CTA */}
        <div id="ask-demo" className="edu-cta-banner-area" style={{ padding: "3rem 0" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="content text-center">
                  <h3 className="title">Happy ERP – amikor minden összeáll.</h3>
                  <p className="description" style={{ maxWidth: 800, margin: "0 auto" }}>
                    Segítünk felmérni a jelenlegi folyamataidat, és megmutatjuk, hogyan tudsz időt és költséget megtakarítani a Happy ERP-vel.
                  </p>
                  <div className="btn-area" style={{ display: "flex", gap: 16, justifyContent: 'center', flexWrap: "wrap", marginTop: 16 }}>
                    {/* <button className="edu-btn" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                      Kérem a bemutatót <i className="icon-arrow-right-line-right"></i>
                    </button> */
										}
										<Demo title={t('erpPage.hero.ctaDemo')}/>
                    <button className="edu-btn btn-secondary" onClick={(e) => { e.preventDefault(); if (window.openContactModal) window.openContactModal(); }}>
                      Ingyenes konzultáció
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* POS-like info + animated widget */}
        {/*<div className="happy-pos edu-event-details-area edu-event-details edu-section-gap bg-color-white" style={{ overflowX: 'hidden', paddingTop: '20px', paddingBottom: '20px' }}>*/}
        {/*  <div className="container">*/}
        {/*    <div className="row g-5">*/}
        {/*      <div className="col-lg-7">*/}
        {/*        <div className="content" style={{ marginTop: 0 }}>*/}
        {/*          <h4 className="title" style={{ fontSize: 30 }}>még sok más, amire képesek vagyunk</h4>*/}
        {/*          <ul>*/}
        {/*            <li style={{ fontSize: 17 }}>Valós idejű forgalmi adatok bármilyen eszközről, bárhonnan*</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Készletkezelés valós idejű alapanyag fogyással a felütés pillanatában</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Szerkeszthető értesítések minden lényeges dologról, legyen az egy esemény (pl. ültetés, törlés, számla storno), forgalmi vagy készlet információ változásról</li>*/}
        {/*            <li style={{ fontSize: 17 }}><a className="text-primary" href="/termekeink/happy-pos" target="_blank" rel="noreferrer">Mobil rendelésfelvétel</a>, többféle érintésmentes fizetéssel</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Pénztárgép és adóügyi nyomtató integráció</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Megfelel az <a className="text-primary" href="https://ntak.hu/" target="_blank" rel="noreferrer">NTAK adatszolgáltatási</a> kötelezettségnek</li>*/}
        {/*          </ul>*/}
        {/*        </div>*/}
        {/*        <div className="content" style={{ marginTop: 0 }}>*/}
        {/*          <h4 className="title" style={{ fontSize: 30 }}>és még mindig nincs vége</h4>*/}
        {/*          <ul>*/}
        {/*            <li style={{ fontSize: 17 }}>Moduláris felépítés: pénzügy, logisztika, HR, CRM, gyártás és értékesítés</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Valós idejű adatszinkronizálás a vállalati rendszerek között</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Automatizált számlázás, készletkezelés és jóváhagyási folyamatok</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Testreszabható riportok és vezetői dashboardok</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Integráció külső rendszerekkel: NAV, Számlázz.hu, Billingo, webshop, CRM</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Jogosultságkezelés és részletes naplózás a biztonság érdekében</li>*/}
        {/*            <li style={{ fontSize: 17 }}>Több telephely, több pénznem és több nyelv támogatása</li>*/}
        {/*          </ul>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*      <div className="col-lg-5">*/}
        {/*        <RealtimeSyncWidget />*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}

        <IntegrationsCarousel/>
        <FooterOne />
      </Layout>
    </>
  );
};

export default ErpPageContent;
